var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadInquiry = function SvgDownloadInquiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12170_91385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
  }))));
};
export default SvgDownloadInquiry;